// blog data

export const Blogs = [
    {
        id:1,
        name:"My LeetCode Profile",
        tags:["leetcode","dsa","problem-solving"],
        description:"Leetcode coding profile",
        imgSrc:"https://leetcard.jacoblin.cool/Sitheswar?theme=dark&font=Poppins",
        link:"https://leetcode.com/u/sitheswar/",
        imgFit:"contain",
        imgBg:"#1a1a2e"
    },
    {
        id:2,
        name:"My Designs",
        tags:["design","ui/ux","creative"],
        description:"Collection of my creative design works",
        imgSrc:"https://img.icons8.com/color/480/design.png",
        link:"https://drive.google.com/drive/folders/1qAdfZczITXs7614XH0uYoZyWjs3C6uBd?usp=drive_link"
    },
    {
        id:3,
        name:"PDF Works",
        tags:["pdf","documents","msword"],
        description:"PDF Works for my school",
        imgSrc:"https://img.icons8.com/color/480/pdf-2.png",
        link:"https://drive.google.com/drive/folders/1SfDHaoyb8t_I8vq_tmlaV_23RW5BA_4U?usp=sharing"
    },
    {
        id:4,
        name:"My Certificates",
        tags:["certificates","achievements","courses"],
        description:"Professional certifications and course completions",
        imgSrc:"https://img.icons8.com/color/480/certificate.png",
        link:"https://drive.google.com/file/d/1G6bfwOf3vRCoRRyXWXBf39IbeMaLLBEQ/view?usp=sharing"
    }
] 